import hpManagerMenu from './navigation/menu'
import hpManagerHeaderSearch from './navigation/headersearch'
import hpHeaderUser from '@/components/navigation/user'
import breadCrunb from './navigation/breadcrumb'
import StandardTable from '@/components/table/table'
import hpManagerCascader from './cascader/cascader'
import hpmanagermodal from './modal/modal'
import uploadImage  from "./upload/UploadImage";
import filterForm from "./filter/filter";
import dateFilter from "./form/dateFilter";

// import hpManagerTable from './table/table.vue'
const components = [
  hpManagerMenu,
  hpManagerHeaderSearch,
  hpHeaderUser,
  breadCrunb,
  StandardTable,
  hpManagerCascader,
  hpmanagermodal,
  uploadImage,
  filterForm,
  dateFilter
]
const install = function(Vue) {
  components.map(component => {
    Vue.component(component.name, component)
  })
}

export default {
  version: '1.0.0',
  install
}




// WEBPACK FOOTER //
// ./src/components/index.js